import { render, staticRenderFns } from "./LostPassword.vue?vue&type=template&id=fab206de"
import script from "./LostPassword.vue?vue&type=script&lang=js"
export * from "./LostPassword.vue?vue&type=script&lang=js"
import style0 from "./LostPassword.vue?vue&type=style&index=0&id=fab206de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports